/* RS system page: stage, add/remove units, persona copy, dial-in chart,
   roast color, Moment cooling, Cupping Manager diagram, dock.
   Copy comes from the data-rss-copy block (locale keys os.rss.*). */
(function () {
  var root = document.querySelector('.rss');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var COPY = JSON.parse(root.querySelector('[data-rss-copy]').textContent);
  var ASSET = JSON.parse(root.querySelector('[data-rss-assets]').textContent);
  var T = function (k) { return COPY[k] != null ? COPY[k] : ''; };
  var fill = function (k, map) { var s = T(k); for (var p in map) s = s.split('#' + p + '#').join(map[p]); return s; };
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOTURL = (root.getAttribute('data-root') || '/').replace(/\/$/, '');

  /* device footprints in mm, from the cut-out photographs */
  var DEV = { omni: { w: 106.1, h: 175 }, ti: { w: 186, h: 147 }, rs: { w: 164, h: 139 }, moment: { w: 131, h: 230 } };
  var NAMES = { rs: 'RS Extract', ti: 'Microbalance Ti', moment: 'Moment', omni: 'Omni' };
  var ORDER = ['omni', 'ti', 'rs', 'moment'];
  var KITS = { 1: 'brew-control-system-rs', 2: 'sensory-brew-control-system-rs', 3: 'sensory-brew-control-system-ultimate-rs' };
  var FAMILY = { producer: 'green', exporter: 'green', importer: 'green', q: 'q', roaster: 'roast', home: 'roast', cafe: 'bar', hobby: 'hobby', educator: 'teach', competitor: 'comp' };
  var NEED = { producer: 2, exporter: 2, importer: 3, q: 3, roaster: 3, cafe: 2, hobby: 3, home: 3, educator: 3, competitor: 2 };

  /* ---------- state ---------- */
  var level = 3;
  var kp = new URLSearchParams(location.search).get('kit');
  if (!kp) { try { var rm = new URL(document.referrer).pathname.match(/\/products\/([^\/?#]+)/); if (rm && new URL(document.referrer).host === location.host) kp = rm[1]; } catch (e) {} }
  if (kp) { for (var l in KITS) if (KITS[l] === kp || String(l) === kp) level = +l; }
  function currentRole() {
    var r = null;
    try { if (window.OS && OS.currentId) r = OS.currentId(); } catch (e) {}
    if (!r) { try { var p = JSON.parse(localStorage.getItem('difluid_persona') || 'null'); r = p && p.id; } catch (e) {} }
    return FAMILY[r] ? r : 'roaster';
  }
  var role = currentRole();
  var has = function (u) { return u === 'rs' || u === 'ti' || (u === 'moment' && level >= 2) || (u === 'omni' && level === 3); };

  /* ---------- unit chips (top, phone, bottom, dock) ---------- */
  var tick = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M2 5.2 4.2 7.4 8 2.8"/></svg>';
  var plus = '<svg viewBox="0 0 10 10" aria-hidden="true"><path d="M5 1.5v7M1.5 5h7"/></svg>';
  $$('[data-units]').forEach(function (box) {
    box.innerHTML = ['rs', 'ti', 'moment', 'omni'].map(function (u) {
      if (u === 'rs' || u === 'ti') return '<span class="rss-unit rss-fixed" title="' + T('unit.included') + '"><span class="rss-mk">' + tick + '</span>' + NAMES[u] + '</span>';
      return '<button type="button" class="rss-unit" data-toggle="' + u + '" aria-pressed="true"><span class="rss-mk"><span class="rss-i-on">' + tick + '</span><span class="rss-i-off">' + plus + '</span></span>' + NAMES[u] + '</button>';
    }).join('');
  });
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]'); if (t) { toggle(t.getAttribute('data-toggle')); return; }
    var a = e.target.closest('[data-add]'); if (a) setLevel(a.getAttribute('data-add') === 'omni' ? 3 : Math.max(level, 2));
  });
  function toggle(u) {
    var next = level, note = '';
    if (u === 'moment') { if (level >= 2) { if (level === 3) note = T('note.removed'); next = 1; } else next = 2; }
    if (u === 'omni') { if (level === 3) next = 2; else { if (level === 1) note = T('note.added'); next = 3; } }
    setLevel(next, note);
  }
  var noteT = null;
  function setNote(t) { $$('[data-note]').forEach(function (n) { n.textContent = t; }); clearTimeout(noteT); if (t) noteT = setTimeout(function () { setNote(''); }, 5200); }
  function paintToggles() {
    $$('[data-toggle]').forEach(function (b) {
      var u = b.getAttribute('data-toggle'), on = has(u);
      b.setAttribute('aria-pressed', on); b.title = fill(on ? 'unit.remove' : 'unit.add', { NAME: NAMES[u] });
    });
  }

  /* ---------- stage ---------- */
  var stage = $('#stage'), labels = $('#labels'), frame = $('#frame');
  var devEl = {}, labEl = {};
  ORDER.forEach(function (u) {
    var d = document.createElement('div'); d.className = 'rss-dev';
    d.innerHTML = '<img alt="' + NAMES[u] + '" src="' + ASSET[u] + '" decoding="async">'; stage.appendChild(d); devEl[u] = d;
    var l = document.createElement('div'); l.className = 'rss-lab';
    l.innerHTML = '<span class="rss-eyebrow">' + T('stage.' + u) + '</span><span class="rss-nm">' + NAMES[u] + '</span>'; labels.appendChild(l); labEl[u] = l;
  });
  var flow = document.createElement('div'); flow.className = 'rss-flowline'; labels.appendChild(flow);
  var rtl = getComputedStyle(root).direction === 'rtl';
  function layout() {
    var W = frame.clientWidth, narrow = W < 700;
    var cap = Math.max(180, Math.min(540, W * 0.4, innerHeight - 400));
    var gap = narrow ? 8 : 44, on = ORDER.filter(has);
    var sumW = on.reduce(function (a, u) { return a + DEV[u].w; }, 0) + gap * (on.length - 1);
    var maxH = Math.max.apply(null, on.map(function (u) { return DEV[u].h; }));
    var s = Math.min(W * (narrow ? 0.94 : 0.8) / sumW, cap * 0.74 / maxH);
    var H = narrow ? Math.max(170, maxH * s / 0.74) : cap; frame.style.height = H + 'px';
    var base = H * 0.12, x = (W - sumW * s) / 2, pos = {};
    on.forEach(function (u) { pos[u] = x; x += (DEV[u].w + gap) * s; });
    var first = on[0], last = on[on.length - 1];
    ORDER.forEach(function (u) {
      var w = DEV[u].w * s, d = devEl[u], l = labEl[u], px = pos[u];
      if (px == null) px = u === 'omni' ? pos[first] - w - W * 0.18 : pos[last] + (DEV[last].w + gap) * s + W * 0.18;
      d.style.width = w + 'px';
      d.style.transform = 'translate(' + px + 'px,' + (-base) + 'px)';
      d.classList.toggle('rss-gone', !has(u));
      l.style.transform = 'translateX(calc(' + (px + w / 2) + 'px - 50%))';
      l.classList.toggle('rss-gone', !has(u));
    });
    var c0 = pos[first] + DEV[first].w * s / 2, c1 = pos[last] + DEV[last].w * s / 2;
    flow.style.left = c0 + 'px'; flow.style.width = (c1 - c0) + 'px';
  }
  addEventListener('resize', layout);

  /* ---------- copy ---------- */
  function swap(el, txt, now) {
    if (!el || el.textContent === txt) return;
    if (now) { el.textContent = txt; return; }
    el.classList.add('rss-out'); setTimeout(function () { el.textContent = txt; el.classList.remove('rss-out'); }, 200);
  }
  function paintCopy(now) {
    var f = FAMILY[role];
    swap($('#kitName'), T('kit.' + level), now);
    $$('[data-kitname]').forEach(function (e) { swap(e, T('kit.' + level), now); });
    swap($('#heroH'), T('hero.' + role + '.' + level + '.h'), now); swap($('#heroP'), T('hero.' + role + '.' + level + '.p'), now);
    swap($('#brewH'), T('brew.' + f + '.h'), now); swap($('#brewP'), T('brew.' + f + '.p'), now);
    swap($('#omniH'), T('omni.' + f + '.h'), now); swap($('#omniP'), T('omni.' + f + '.p'), now);
    swap($('#momH'), T('moment.' + f + '.h'), now); swap($('#momP'), T('moment.' + f + '.p'), now);
    $$('[data-shop]').forEach(function (a) { a.href = ROOTURL + '/products/' + KITS[level]; a.setAttribute('aria-label', fill('shop_aria', { KIT: T('kit.' + level) })); });
    var need = NEED[role], n = $('#nudge');
    if (need > level) {
      var t = level === 2 ? T('nudge2.' + role) : T('nudge.' + role);
      var b = need === 3 ? (level === 1 ? T('btn.add_both') : T('btn.add_omni')) : T('btn.add_moment');
      $('#nudgeP').textContent = t; $('#nudgeB').textContent = b; $('#nudgeB').setAttribute('data-to', need); n.hidden = false;
    } else n.hidden = true;
    $('#omniSlot [data-add]').textContent = level === 1 ? T('btn.add_both') : T('btn.add_omni');
    $('#cmMoment').style.opacity = has('moment') ? 1 : 0.4;
    $('#cmMoment').textContent = has('moment') ? T('cm.moment_on') : T('cm.moment_off');
  }
  $('#nudgeB').addEventListener('click', function (e) { setLevel(+e.currentTarget.getAttribute('data-to')); });
  document.addEventListener('os:role', function (e) {
    var r = e.detail && e.detail.role; if (FAMILY[r] && r !== role) { role = r; paintCopy(false); }
  });

  /* ---------- level ---------- */
  function setLevel(l, note) {
    var prev = level; level = l;
    paintToggles(); layout(); paintCopy(false);
    setFold('omni', has('omni')); setFold('moment', has('moment'));
    $$('#adds li').forEach(function (li) { li.classList.toggle('rss-out', !has(li.getAttribute('data-u'))); });
    paintCM(); setNote(note || '');
    if (prev < 3 && l === 3) setTimeout(function () { if (window.rssReplay) { rssReplay('fines'); rssReplay('burr'); } lightChain(); }, 600);
  }
  function setFold(u, open) {
    var f = $('#' + u + 'Fold');
    f.classList.toggle('rss-closed', !open); $('#' + u + 'Slot').classList.toggle('rss-open', !open);
    f.setAttribute('aria-hidden', !open); f.querySelector('.rss-inner').inert = !open;
  }

  /* ---------- brew control chart ---------- */
  var svg = $('#chart');
  var X = function (e) { return 50 + (e - 16) / 8 * 355; }, Y = function (t) { return 290 - (t - 1) / 0.75 * 270; };
  var g = '';
  [16, 18, 20, 22, 24].forEach(function (e) { g += '<line class="rss-grid" x1="' + X(e) + '" x2="' + X(e) + '" y1="20" y2="290"/><text x="' + X(e) + '" y="310" text-anchor="middle">' + e + '</text>'; });
  [1, 1.15, 1.3, 1.45, 1.6, 1.75].forEach(function (t) { g += '<line class="rss-grid" x1="50" x2="405" y1="' + Y(t) + '" y2="' + Y(t) + '"/><text x="42" y="' + (Y(t) + 4) + '" text-anchor="end">' + t.toFixed(2) + '</text>'; });
  g += '<rect class="rss-box" x="' + X(18) + '" y="' + Y(1.45) + '" width="' + (X(22) - X(18)) + '" height="' + (Y(1.15) - Y(1.45)) + '" rx="2"/>';
  g += '<text x="' + (X(22) - 6) + '" y="' + (Y(1.45) + 16) + '" text-anchor="end" style="fill:var(--sense)">SCA</text>';
  g += '<text x="405" y="326" text-anchor="end">' + T('chart.x') + '</text><text x="12" y="14">' + T('chart.y') + '</text><g id="trail"></g><circle class="rss-halo" id="halo" r="12"/><circle class="rss-now" id="now" r="6"/>';
  svg.innerHTML = g;
  var gs = 0, ws = 0, trail = [];
  function brew() { var ey = 20.33 + 0.75 * gs + 0.3 * ws, bev = 252.1 + 20 * ws; return { ey: ey, bev: bev, tds: ey * 15 / bev }; }
  function drawBrew(push) {
    var b = brew();
    if (push) { trail.push(push); if (trail.length > 6) trail.shift(); }
    $('#trail').innerHTML = trail.map(function (p, i) { return '<circle class="rss-trail" cx="' + X(p.ey) + '" cy="' + Y(p.tds) + '" r="3.5" opacity="' + (0.25 + 0.12 * i) + '"/>'; }).join('');
    ['now', 'halo'].forEach(function (id) { var c = $('#' + id); c.setAttribute('cx', X(b.ey)); c.setAttribute('cy', Y(b.tds)); });
    $('#rTds').textContent = b.tds.toFixed(2) + '%'; $('#rEy').textContent = b.ey.toFixed(2) + '%'; $('#rBev').textContent = b.bev.toFixed(1) + ' g';
    if (!push && gs === 0 && ws === 0 && !trail.length && drawBrew.first !== false) { drawBrew.first = false; return; } /* keep the opening line */
    var msg = [];
    if (b.ey > 22) msg.push(T('verdict.high_ey')); else if (b.ey < 18) msg.push(T('verdict.low_ey'));
    if (b.tds > 1.45) msg.push(T('verdict.high_tds')); else if (b.tds < 1.15) msg.push(T('verdict.low_tds'));
    $('#verdict').textContent = msg.length ? msg.join(' ') : fill('verdict.inside', { TDS: b.tds.toFixed(2), EY: b.ey.toFixed(2) });
  }
  $$('[data-move]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var before = brew(), m = btn.getAttribute('data-move');
      if (m === 'reset') { gs = 0; ws = 0; trail.length = 0; drawBrew.first = false; drawBrew(); return; }
      if (m === 'finer') gs = Math.min(3, gs + 1); if (m === 'coarser') gs = Math.max(-4, gs - 1);
      if (m === 'more') ws = Math.min(3, ws + 1); if (m === 'less') ws = Math.max(-3, ws - 1);
      drawBrew(before);
    });
  });
  drawBrew();

  /* ---------- roast color ---------- */
  var ROAST = { light: [78, 91], medium: [60, 69], dark: [42, 47] };
  var ag = function (v) { return ((v - 30) / 70 * 100) + '%'; };
  function roast(k) {
    var b = ROAST[k][0], gv = ROAST[k][1];
    var side = 'left';
    $('#agB').style[side] = ag(b); $('#agG').style[side] = ag(gv);
    $('#agBv').textContent = b.toFixed(1); $('#agGv').textContent = gv.toFixed(1); $('#agD').textContent = (gv - b).toFixed(1);
    $('#ch1').textContent = T('roast.' + k);
    $('#roastLead').textContent = T(k === 'light' ? 'roast.lead_light' : 'roast.lead_dark');
    $('#ch2').textContent = k === 'medium' ? T('omni.t22') : T('chain.fines_' + k);
    $('#ch3').textContent = k === 'medium' ? T('omni.t23') : T('chain.flow_' + k);
    $('#ch4').textContent = k === 'medium' ? T('omni.t24') : T('chain.ey_' + k);
    $$('[data-roast]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-roast') === k); });
    lightChain();
  }
  $$('[data-roast]').forEach(function (b) { b.addEventListener('click', function () { roast(b.getAttribute('data-roast')); }); });
  var chainT = [];
  function lightChain() {
    chainT.forEach(clearTimeout); var ls = $$('#chain .rss-link');
    ls.forEach(function (l) { l.classList.remove('rss-lit'); });
    ls.forEach(function (l, i) { chainT.push(setTimeout(function () { l.classList.add('rss-lit'); }, 180 + i * 260)); });
  }

  /* ---------- Moment cooling ---------- */
  var STG = [[70, 61], [60, 51], [50, 43], [42, 35]];
  $('#stages').innerHTML = STG.map(function (s, i) {
    return '<div class="rss-stg" data-i="' + i + '"><span class="rss-t">' + fill('moment.range', { A: s[0], B: s[1] }) + '</span><span class="rss-n">' + T('moment.note' + (i + 1)) + '</span></div>';
  }).join('');
  var temp = 68, coolOn = !REDUCE, coolVis = false, lastT = 0, coolRaf = null;
  function paintTemp() {
    var t = Math.round(temp); $('#tNow').textContent = t + ' °C';
    $('#tube').style.height = Math.max(6, (temp - 30) / 45 * 100) + '%';
    var idx = -1; STG.forEach(function (s, i) { if (idx < 0 && t <= s[0] && t >= s[1]) idx = i; }); if (idx < 0) idx = t > 70 ? 0 : 3;
    $$('.rss-stg').forEach(function (s) { s.classList.toggle('rss-on', +s.getAttribute('data-i') === idx); });
    $('#tStage').textContent = fill('moment.stage', { N: idx + 1 });
  }
  function coolTick(now) {
    if (lastT) { temp -= (now - lastT) / 1000 * 2.2; if (temp < 35) temp = 70; paintTemp(); }
    lastT = now; coolRaf = (coolOn && coolVis) ? requestAnimationFrame(coolTick) : null; if (!coolRaf) lastT = 0;
  }
  function coolKick() { if (!coolRaf && coolOn && coolVis) coolRaf = requestAnimationFrame(coolTick); }
  paintTemp();
  if (!coolOn) $('#coolBtn').textContent = T('moment.play');
  $('#coolBtn').addEventListener('click', function (e) { coolOn = !coolOn; e.currentTarget.textContent = coolOn ? T('moment.t05') : T('moment.play'); coolKick(); });
  new IntersectionObserver(function (es) { es.forEach(function (e) { coolVis = e.isIntersecting; coolKick(); }); }, { threshold: 0.2 }).observe($('#moment'));

  /* ---------- Cupping Manager diagram ---------- */
  var cm = $('#cm');
  var N = {
    omni: { x: 20, y: 40, w: 255, t: 'Omni', s: T('cm.omni_sub'), u: 'omni' },
    ti: { x: 20, y: 150, w: 255, t: 'Microbalance Ti', s: T('cm.ti_sub'), u: 'ti' },
    rs: { x: 20, y: 240, w: 255, t: 'RS Extract', s: T('cm.rs_sub'), u: 'rs' },
    moment: { x: 20, y: 330, w: 255, t: 'Moment', s: T('cm.moment_sub'), u: 'moment' },
    rca: { x: 335, y: 20, w: 220, t: T('cm.rca'), c: 'var(--t-roast)', u: 'omni' },
    pa: { x: 335, y: 80, w: 220, t: T('cm.pa'), c: 'var(--t-particle)', u: 'omni' },
    br: { x: 335, y: 150, w: 220, t: T('cm.br'), c: 'var(--t-brew-rec)', u: 'ti' },
    bc: { x: 335, y: 240, w: 220, t: T('cm.bc'), c: 'var(--t-brew-ctl)', u: 'rs' },
    cmn: { x: 610, y: 180, w: 180, t: T('cm.cmn'), s: T('cm.cmn_sub'), c: 'var(--t-cup)' },
    bean: { x: 820, y: 180, w: 166, t: T('cm.bean'), s: T('cm.bean_sub'), c: 'var(--t-bean)' }
  };
  var E = [['omni', 'rca'], ['omni', 'pa'], ['ti', 'br'], ['rs', 'bc'], ['rca', 'cmn'], ['br', 'cmn'], ['bc', 'cmn'], ['moment', 'cmn'], ['pa', 'bean'], ['cmn', 'bean']];
  var hgt = function (n) { return n.s ? 52 : 40; }, cy = function (n) { return n.y + hgt(n) / 2; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var h = '';
  E.forEach(function (p) {
    var A = N[p[0]], B = N[p[1]], x1 = A.x + A.w, y1 = cy(A), x2 = B.x, y2 = cy(B), mx = (x1 + x2) / 2;
    var d = p[0] === 'moment' ? 'M' + x1 + ' ' + y1 + ' L 560 ' + y1 + ' C 595 ' + y1 + ', 580 ' + y2 + ', ' + x2 + ' ' + y2
      : (p[1] === 'bean' && p[0] === 'pa') ? 'M' + x1 + ' ' + y1 + ' C ' + (x1 + 180) + ' ' + y1 + ', ' + (x2 - 60) + ' ' + (y2 - 30) + ', ' + x2 + ' ' + (y2 - 8)
      : 'M' + x1 + ' ' + y1 + ' C ' + mx + ' ' + y1 + ', ' + mx + ' ' + y2 + ', ' + x2 + ' ' + y2;
    var u = (A.u === 'omni' || B.u === 'omni') ? 'omni' : (A.u === 'moment' ? 'moment' : '');
    h += '<g class="rss-edge" data-u="' + u + '"><path class="rss-wire" d="' + d + '"/><path class="rss-flow" d="' + d + '"/></g>';
  });
  Object.keys(N).forEach(function (k) {
    var n = N[k], H = hgt(n), u = (n.u === 'omni' || n.u === 'moment') ? n.u : '';
    h += '<g class="rss-node" data-u="' + u + '"><rect class="rss-nb" x="' + n.x + '" y="' + n.y + '" width="' + n.w + '" height="' + H + '" rx="15"/>';
    if (n.c) h += '<circle cx="' + (n.x + 18) + '" cy="' + cy(n) + '" r="5" fill="' + n.c + '"/>';
    var tx = n.x + (n.c ? 32 : 16);
    h += n.s ? '<text class="rss-nt" x="' + tx + '" y="' + (n.y + 22) + '">' + esc(n.t) + '</text><text class="rss-ns" x="' + tx + '" y="' + (n.y + 40) + '">' + esc(n.s) + '</text>'
      : '<text class="rss-nt" x="' + tx + '" y="' + (n.y + 25) + '">' + esc(n.t) + '</text>';
    h += '</g>';
  });
  cm.innerHTML = h;
  /* longer words in some languages: shrink a label until it fits its box */
  function fitCM() {
    $$('#cm .rss-node').forEach(function (gn) {
      var r = gn.querySelector('rect'), right = +r.getAttribute('x') + +r.getAttribute('width') - 12;
      gn.querySelectorAll('text').forEach(function (t) {
        var size = t.classList.contains('rss-nt') ? 13 : 12; t.style.fontSize = size + 'px';
        var guard = 0;
        while (guard++ < 8) { var bb = t.getBBox(); if (bb.x + bb.width <= right || size <= 9) break; size -= 0.5; t.style.fontSize = size + 'px'; }
      });
    });
  }
  function paintCM() { $$('#cm [data-u]').forEach(function (gn) { var u = gn.getAttribute('data-u'); gn.classList.toggle('rss-off', !!u && !has(u)); }); }

  /* ---------- dock, kept above the site's phone tabs ---------- */
  var dock = $('#dock'), topVis = true, closeVis = false;
  function dockPaint() { var on = !topVis && !closeVis; dock.classList.toggle('rss-on', on); if (on) dockOffset(); }
  var vis = new Map();
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { vis.set(e.target, e.isIntersecting); }); topVis = Array.from(vis.values()).some(Boolean); dockPaint(); }, { threshold: 0 });
  $$('.rss-hero [data-sys]').forEach(function (el) { io.observe(el); });
  new IntersectionObserver(function (es) { es.forEach(function (e) { closeVis = e.isIntersecting; dockPaint(); }); }, { threshold: 0 }).observe($('#close .rss-build'));
  function dockOffset() {
    var tabs = document.querySelector('.os-tabs'), b = 0;
    if (tabs) { var r = tabs.getBoundingClientRect(); if (r.height && getComputedStyle(tabs).display !== 'none') b = Math.max(0, innerHeight - r.top + 8); }
    root.style.setProperty('--rss-dock-b', b + 'px');
  }
  addEventListener('resize', dockOffset); addEventListener('scroll', dockOffset, { passive: true }); setInterval(function () { if (dock.classList.contains('rss-on')) dockOffset(); }, 700);

  /* ---------- 3D, loaded when it nears the screen ---------- */
  var r3 = $('#rs3d'), r3Started = false;
  function load(src) { return new Promise(function (ok, no) { var s = document.createElement('script'); s.src = src; s.async = false; s.onload = ok; s.onerror = no; document.head.appendChild(s); }); }
  if (r3 && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es, ob) {
      if (r3Started || !es.some(function (e) { return e.isIntersecting; })) return;
      r3Started = true; ob.disconnect();
      window.__RSS_ASSET = ASSET;
      load(ASSET.three).then(function () { return load(ASSET.glb); }).then(function () { return load(ASSET['3d']); }).catch(function () {});
    }, { rootMargin: '600px 0px' }).observe(r3);
  }

  /* ---------- go ---------- */
  roast('medium');
  paintToggles(); layout(); paintCopy(true);
  setFold('omni', has('omni')); setFold('moment', has('moment'));
  $$('#adds li').forEach(function (li) { li.classList.toggle('rss-out', !has(li.getAttribute('data-u'))); });
  paintCM(); dockOffset();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { layout(); fitCM(); }); else fitCM();
  if ('ResizeObserver' in window) new ResizeObserver(layout).observe(frame);
  window.rssSetLevel = setLevel;
})();
